import React, { useMemo } from 'react';
import { useEffect, useState } from "react";
import { getAllData, } from '../../../../services/ApiCallingUserServices';
import RichTextBox from '../../../../customControl/RichTextBox';
import "react-datepicker/dist/react-datepicker.css";
import { htmlToText } from 'html-to-text';
import CustomSelection from '../../../../customControl/CustomSelection';
import { useDispatch, useSelector } from 'react-redux';
import { errorActions } from '../../../../_actions/error.action';
import { CommonFileURLWithFolder } from '../../../../ImageUpload/ImageCommon';

const VendorAbout = (props) => {
    const {
        handleAboutAdd,
        handleAboutPlaceDisable,
        handleDeleteList,
        retriveflag,
        aboutdatalist,
        editableflag,
        ischecked
    } = props
    const errorStatus = useSelector(state => state.errorStatus.isError);
    const aboutStatus = useSelector(state => state.errorStatus.isAboutPlace);
    const dispatch = useDispatch();
    const [aboutplacecitylist, setAboutPlaceCityList] = useState([]);
    const [citylabel, setCityLable] = useState('');
    const [deletefilelist, setDeleteFileList] = useState([]);
    const [aboutplaceid, setAboutPlaceId] = useState(0);
    const [aboutseqno, setAboutSeqNo] = useState(0)
    const [datacitydetails, setCityDetails] = useState([]);
    const [aboutplaceerror, setAboutPlaceError] = useState('')
    const [aboutcitydisable, setAboutCityDisable] = useState(false)
    const [allaboutcity, setAllAboutCity] = useState([]);
    const [fileselected, setSelectedFile] = useState();
    const [placeimagename, setImageName] = useState('');
    const [placeimagepath, setImagePath] = useState('');
    const [retrivecomplete, setRetriveComplete] = useState(0);
    const [richboxheight, setRichBoxHeight] = useState(false);
    const [aboutplacebtntext, setAboutPlaceBtnText] = useState('Add');
    const [placedetails, setPlaceDetails] = useState('');
    const [editorRef, setEditorRef] = useState(null);

    const getaboutplacecity = async () => {
        await getAllData('/master/v1/getpackagelocationcity').then((response) => {
            setAboutPlaceCityList(response.data?.filter(IsAct => IsAct.IsActive === true));
            setAllAboutCity(response.data);
        });
    }

    const aboutplacecitydatalist = aboutplacecitylist?.map((value) => ({
        label: value.City,
        value: value.LocationId
    }));

    const handlecityonchange = (e) => {
        setAboutPlaceError('');
        setAboutPlaceId(e.value);
        setCityLable(e.label);
        dispatch(errorActions.resetallstatusflag())
        getaboutplacedetailsfromlocmaster(e.value)
    }

    const [aboutCityDetail, setAboutCityDetail] = useState('')
    const getaboutplacedetailsfromlocmaster = async (id) => {
        await getAllData('/master/vendor/v1/vengetpkgaboutplacedetails?CityId=' + id).then(res => {
            res.data?.map(obj => {
                setAboutPlaceId(obj.LocationId)
                setPlaceDetails(obj.CityDetail)
                setAboutCityDetail(htmlToText(obj.CityDetail))
                setImagePath(CommonFileURLWithFolder + obj.PlaceImagePath)
                setImageName(obj.PlaceImageName)
            })
        })
    }

    const handleeditaboutplacedetail = (id) => {
        const newList = datacitydetails?.map((item) => {
            if (item.SeqNo === id) {
                const updatedItem = {
                    ...item,
                    LocationId: aboutplaceid,
                    CityName: citylabel,
                    CityDetails: placedetails,
                    PlaceImageName: placeimagename,
                    PlaceImagePath: placeimagepath,
                    PlaceImage: fileselected
                    //IsChecked: !item.IsChecked,
                };
                return updatedItem;
            }

            return item;
        });
        setCityDetails(newList);
        handleAboutAdd(newList);
        setAboutPlaceId(0);
        setPlaceDetails('');
        setSelectedFile();
        setImageName('');
        setImagePath('');
        setAboutCityDetail('')
        setAboutPlaceBtnText('Add')
        const input = document.getElementById('txtcityimages');
        if (input) {
            input.value = "";
        }
        dispatch(errorActions.resetallstatusflag())
    }

    const CityClick = () => {
        const abc = datacitydetails?.map(value => {
            return value.LocationId;
        })
        const duplicatecity = abc.includes(aboutplaceid)
        if (aboutplacebtntext === 'Add') {
            if (aboutplaceid === 0) {
                dispatch(errorActions.start());
                setAboutPlaceError('Please enter all required field');
                return;
            }
            else if (placedetails === null) {
                dispatch(errorActions.start());
                setAboutPlaceError('Kindly add city details in location master');
                return;
            }
            else {
                if (duplicatecity) {
                    dispatch(errorActions.start());
                    setAboutPlaceError('City already exist');
                    return;
                }
                setAboutSeqNo(aboutseqno + 1)
                handleAboutAdd([...datacitydetails, { SeqNo: aboutseqno + 1, CityName: citylabel, LocationId: aboutplaceid, CityDetails: placedetails, PlaceImageName: placeimagename, PlaceImagePath: placeimagepath, PlaceImage: fileselected }])
                setCityDetails([...datacitydetails, { SeqNo: aboutseqno + 1, CityName: citylabel, LocationId: aboutplaceid, CityDetails: placedetails, PlaceImageName: placeimagename, PlaceImagePath: placeimagepath, PlaceImage: fileselected }]);
                setAboutPlaceId(0);
                setPlaceDetails('');
                setSelectedFile();
                setImageName('');
                setImagePath('');
                setAboutCityDetail('')
                const input = document.getElementById('txtcityimages');
                if (input) {
                    input.value = "";
                }

                handleAboutPlaceDisable(false);
                dispatch(errorActions.aboutplaceincrement())
                dispatch(errorActions.resetallstatusflag())
            }

        }
        if (aboutplacebtntext !== 'Add') {
            if (aboutplaceid === 0) {
                dispatch(errorActions.start());
                setAboutPlaceError('Please enter all required field');
                return;
            }
            else if (placedetails === null) {
                dispatch(errorActions.start());
                setAboutPlaceError('Kindly add city details in location master');
                return;
            }
            else {
                if (checkduplicatecity !== aboutplaceid) {
                    if (duplicatecity) {
                        dispatch(errorActions.start());
                        setAboutPlaceError('City already exist');
                        return;
                    }
                }
                dispatch(errorActions.resetallstatusflag());
                handleeditaboutplacedetail(seqnoedit);
                handleAboutPlaceDisable(false);
            }
        }
    };

    const cityremovev = (id, e) => {
        if (aboutplacebtntext !== 'Add') {
            datacitydetails?.map((obj) => {
                if (obj.SeqNo === id) {
                    setDeleteFileList([...deletefilelist, { ImagePath: obj.PlaceImagePath }])
                    handleDeleteList([...deletefilelist, { ImagePath: obj.PlaceImagePath }])
                }
            });
        }
        handleAboutAdd((oldState) => oldState?.filter((item) => item.SeqNo !== id));
        setCityDetails((oldState) => oldState?.filter((item) => item.SeqNo !== id));

        setAboutPlaceId(0);
        setPlaceDetails('');
        setSelectedFile();
        setImagePath('');
        setAboutCityDetail('')
        setAboutPlaceBtnText('Add');
        const input = document.getElementById('txtcityimages');
        if (input) {
            input.value = "";
        }

        setAboutPlaceError('');

        handleAboutPlaceDisable(false);

        dispatch(errorActions.aboutplacedecrement());
        dispatch(errorActions.resetallstatusflag());



    }

    const [seqnoedit, setSeqNoEdit] = useState(0)
    const [checkduplicatecity, setCheckDuplicateCity] = useState(0)
    const cityeditdata = (id, e) => {
        dispatch(errorActions.resetallstatusflag());
        setAboutPlaceBtnText('Update');
        datacitydetails?.filter(obj => obj.SeqNo === id).map((ele, index) => {
            setSeqNoEdit(ele.SeqNo)
            setCityLable(ele.CityName);
            setAboutPlaceId(ele.LocationId);
            setCheckDuplicateCity(ele.LocationId)
            setPlaceDetails(ele.CityDetails)
            setAboutCityDetail(htmlToText(ele.CityDetails))
            setRetriveComplete(htmlToText(ele.CityDetails).length);
            setSelectedFile(ele.PlaceImage);
            setImageName(ele.PlaceImageName);
            setImagePath(ele.PlaceImagePath);
            let allaboutcitylist = allaboutcity?.filter(IsAct => IsAct.IsActive === true);
            setAboutPlaceCityList(allaboutcity?.filter(IsAct => IsAct.IsActive === true));
            setAboutCityDisable(false);
            if (!allaboutcitylist?.find(IsAboutCity => IsAboutCity.LocationId === ele.LocationId)) {
                setAboutCityDisable(true)
                setAboutPlaceCityList((prvAboutdata) => prvAboutdata?.length > 0 ? [...prvAboutdata, allaboutcity?.find(iscity => iscity.LocationId === ele.LocationId)] : [])

            }
        }
        )

    }

    const config = useMemo(() => ({
        readonly: true, // all options from https://xdsoft.net/jodit/doc/,
        // height: '100%',
        width: '100%',
        statusbar: false,
        removeButtons: ["link", "about"],
        toolbarAdaptive: false,
        height: 'auto',
        maxHeight: richboxheight === true ? 200 : 500,
        disablePlugins: ["source"],
        disabled: retriveflag ? false : false,
    }), [retriveflag]);

    useEffect(() => {
        const richtexteboxheight = document.getElementById("layoutSidenav_content").clientWidth
        if (richtexteboxheight > 912) {
            setRichBoxHeight(true)
        }
        else {
            setRichBoxHeight(false)
        }
    }, []);

    const validation = () => {
        setAboutPlaceError('Please enter about place detail')
        let aboutcllopased = document.getElementById("AboutPlaceError")
        if (aboutcllopased.ariaExpanded === "false")
            document.querySelector("#AboutPlaceError").click();
        dispatch(errorActions.start())
    }

    useEffect(() => {
        getaboutplacecity()
    }, [])

    useEffect(() => {
        if (retriveflag) {
            setCityDetails(aboutdatalist)
            setAboutSeqNo(aboutdatalist.length)
        }
        else (
            setAboutCityDisable(retriveflag)
        )

    }, [aboutdatalist, retriveflag])

    useEffect(() => {
        if (!errorStatus) {
            setAboutPlaceError('');
        }
    }, [errorStatus])

    useEffect(() => {
        if (aboutStatus && ischecked) {
            validation()
        }
    }, [aboutStatus])

    return (
        <>
            <div class="accordion-item mb-3">
                <h2 class="accordion-header" id="panelsStayOpen-headingSeven">
                    <button class="accordion-button collapsed" type="button" id="AboutPlaceError" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseSeven" aria-expanded="false" aria-controls="panelsStayOpen-collapseSeven">
                        About Place
                    </button>
                </h2>
                <div id="panelsStayOpen-collapseSeven" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingSeven">
                    <div class="accordion-body">
                        <div class="col-lg-12 col-md-12 col-sm-12 mb-3">
                            <div class="row">
                                <div class="row">
                                    <div className='col-lg-12 col-sm-12 '>
                                        <div className='row'>
                                            {aboutplaceerror && <p className='text-center text-danger'>{aboutplaceerror}</p>}
                                            <div class="col-lg-2 col-md-3 mb-1">
                                                <label class="col-form-label required">Select City</label>
                                            </div>
                                            <div class="col-lg-4 mb-1 col-md-9">

                                                <CustomSelection
                                                    datalist={aboutplacecitydatalist}
                                                    fieldid={aboutplaceid}
                                                    SelectionChange={handlecityonchange}
                                                    isdisable={editableflag}
                                                    isactivedisable={aboutcitydisable}
                                                    issearchable={true}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-lg-12 col-sm-12 '>
                                        <div className='row'>
                                            <div class="col-lg-2 col-md-3 mb-1">
                                                <label class="col-form-label required">City Details</label>
                                            </div>
                                            <div class="col-lg-10 mb-1 col-md-9">
                                                <RichTextBox
                                                    field="CityDetailsD"
                                                    fieldvalue={placedetails !== null ? placedetails : ''}
                                                    tabIndex={1}
                                                    OnChangeofRichBox={(value) => { setPlaceDetails(value) }}
                                                    textconfig={config}
                                                    setRef={setEditorRef}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-lg-6 col-sm-6'>
                                        <div className='row'>
                                            <div class="col-lg-4 col-md-12 col-sm-12 mb-lg-1">
                                                <label class="col-form-label">City Image</label>

                                            </div>
                                            <div class="col-lg-8 col-md-12 col-sm-12 mb-lg-1">
                                                {(placeimagepath && placeimagepath !== `${CommonFileURLWithFolder}null` && placeimagepath !== CommonFileURLWithFolder) &&
                                                    (
                                                        <>
                                                            <div className="col-lg-3 col-md-3 col-6 my-2 cityimage">
                                                                <img src={placeimagepath} className="cityimage" alt='' />
                                                            </div>
                                                        </>
                                                    )}

                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-12 mb-1 col-md-12 d-flex justify-content-center">
                                        <button type="button" onClick={CityClick} disabled={editableflag ? true : false} class="btn btn-primary mx-1" id="btnAboutPlaceAdd">{aboutplacebtntext}</button>
                                    </div>
                                    <div className='mb-1 col-lg-12 col-md-12 mt-3'>
                                        <table id="data" className="table table-hover" >
                                            <thead>
                                                <tr>
                                                    <th>City</th>
                                                    <th className='text-end pe-4'>Edit</th>
                                                    <th className='text-end pe-4'>Remove</th>
                                                </tr>
                                            </thead>
                                            <tbody id="location-data">
                                                {datacitydetails?.map((element, index) => {
                                                    return (
                                                        <tr class="ReactTable" key={index}>
                                                            <td >{element.CityName}</td>
                                                            <td className='text-end'><button type="button"
                                                                onClick={(e) => { cityeditdata(element.SeqNo, e) }}
                                                                class="btn btn-primary" id="btnedit" disabled={editableflag}>Edit</button></td>
                                                            <td className='text-end'><button type="button" onClick={(e) => { cityremovev(element.SeqNo, e) }} class="btn btn-primary mx-1" id="btnAdd" disabled={editableflag}>Remove</button></td>
                                                        </tr>
                                                    );
                                                })}

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default VendorAbout